import { render } from "./questionnaire.vue?vue&type=template&id=c3f3009c&scoped=true"
import script from "./questionnaire.vue?vue&type=script&lang=js"
export * from "./questionnaire.vue?vue&type=script&lang=js"

import "./questionnaire.vue?vue&type=style&index=0&id=c3f3009c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3f3009c"]])

export default __exports__